<template>
  <div>
    <v-card>
      <!-- <v-card-text> -->
      <div class="pa-4">
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex md4 xs12>
              <v-subheader class="queryLabel">{{ labels.polNo }}</v-subheader>
              <span class="queryValue">{{ polMaster.polNo }}</span>
            </v-flex>
            <v-flex md4 xs12>
              <v-subheader class="queryLabel">{{ labels.renEndtCnt }}</v-subheader>
              <span class="queryValue">{{ formatRenCnt(polMaster.renCnt) }} / {{ formatEndtCnt(polMaster.endtCnt) }}</span>
            </v-flex>
            <v-flex md2 xs12>
              <v-subheader class="queryLabel">{{ labels.polStat }}</v-subheader>
              <div class="queryValue">{{ polMaster.polStat }} - {{ policyForm.polStatDesc }}</div>
            </v-flex>
            <v-flex md2 xs12>
              <div class="queryOrangeValue">{{ formatTranRel(polMaster.tranRel) }}</div>
              <div class="queryOrangeValue">{{ policyForm.premOS }}</div>
            </v-flex>
            <v-flex md4 xs12>
              <v-subheader class="queryLabel">{{ labels.polType }}</v-subheader>
              <div class="queryValue">{{ polMaster.polType }} - {{ policyInfo.polTypeDesc }}</div>
            </v-flex>
            <v-flex md4 xs12>
              <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
              <div class="queryValue" v-if="polMaster.branch !== ''">{{ polMaster.branch }} - {{ policyForm.brnDesc }}</div>
            </v-flex>
            <v-flex md4 xs12>
              <v-subheader class="queryLabel">{{ labels.insdName1 }}</v-subheader>
              <span class="queryValue">{{ polMaster.insdName1 }}</span>
            </v-flex>
            <v-flex md4 xs12>
              <v-subheader class="queryLabel">{{ labels.dri }}</v-subheader>
              <div class="queryValue">{{ formatDRI(polMaster.dri) }}</div>
            </v-flex>
            <v-flex md4 xs12>
              <v-subheader class="queryLabel">{{ labels.busSrc }}</v-subheader>
              <div class="queryValue" v-if="polMaster.busSrc !== ''">{{ polMaster.busSrc }} - {{ policyForm.busSrcDesc }}</div>
            </v-flex>
            <v-flex md4 xs12>
              <v-subheader class="queryLabel">{{ labels.cnNo }} / {{ labels.cnDate }}</v-subheader>
              <div class="queryValue" v-if="polMaster.cnNo !== '' && polMaster.cnDate !== ''">
                {{ polMaster.cnNo }} / {{ formatDate(polMaster.cnDate) }}
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-spacer class="mt-3"></v-spacer>
      <v-tabs v-model="tabMenu" show-arrows>
        <v-tab ripple :key="1">{{ labels.policyHeader }}</v-tab>
        <v-tab ripple :key="2" @click="doPolicyDetails">{{ labels.policyDetails }}</v-tab>
        <v-tab ripple :key="3" @click="doPolicySummary">{{ labels.policySummary }}</v-tab>
        <v-tab ripple :key="4" @click="doPolicyReinsurance">{{ labels.policyReinsurance }}</v-tab>
        <v-tab ripple :key="5" :disabled="!(polMaster.appCoIns === true)">{{ labels.coinsSvcFee }}</v-tab>
        <v-tab ripple :key="6" v-if="showTab">{{ labels.claimsInformation }}</v-tab>
        <v-tab ripple :key="7" v-if="showTab">{{ labels.custLog }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabMenu" :touchless="true">
        <v-tab-item :key="1" :transition="false" :reverse-transition="false">
          <v-card :loading="loading">
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.cty }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.cty !== ''">{{ polMaster.cty }} - {{ policyForm.ctyDesc }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.fund }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.fund !== ''">{{ polMaster.fund }} - {{ policyForm.fundDesc }}</div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.comDate }}</v-subheader>
                    <div class="queryValue">{{ formatDate(polMaster.comDate) }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
                    <div class="queryValue">{{ formatDate(polMaster.expDate) }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.uwYr }}</v-subheader>
                    <div class="queryValue">{{ polMaster.uwYr }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.tranDate }}</v-subheader>
                    <div class="queryValue">{{ formatDate(polMaster.tranDate) }}</div>
                  </v-flex>
                  <v-flex md4 xs12 v-show="polMaster.endtCnt > 0">
                    <v-subheader class="queryLabel">{{ labels.endtDate }}</v-subheader>
                    <div class="queryValue">{{ formatDate(polMaster.endtDate) }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.acctPeriod }}</v-subheader>
                    <div class="queryValue">{{ polMaster.acctMth + '/' + polMaster.acctYr }}</div>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.firstIssDate }}</v-subheader>
                    <div class="queryValue">{{ formatDate(polMaster.firstIssDate) }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.acceptDate }}</v-subheader>
                    <div class="queryValue">{{ formatDate(polMaster.acceptDate) }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.acceptTime }}</v-subheader>
                    <div class="queryValue">{{ polMaster.acceptTime }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.prevPolNo }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.prevPolNo">{{ polMaster.prevPolNo }}</div>
                    <div class="queryValue" v-else>-</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.isMoc }}</v-subheader>
                    <div class="queryValue">{{ formatYesNo(polMaster.moCmpUpld) }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.moCmpNo }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.moCmpNo">{{ polMaster.moCmpNo }}</div>
                    <div class="queryValue" v-else>-</div>
                  </v-flex>
                </v-layout>
                <v-divider />
                <v-layout row wrap>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.renPolNo }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.renPolNo">{{ polMaster.renPolNo }}</div>
                    <div class="queryValue" v-else>-</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.acctNo1 }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.acctNo1">{{ polMaster.acctNo1 }} - {{ policyForm.acctNo1Name }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.acctNoSfx">{{ polMaster.acctNoSfx }} - {{ policyForm.acctNoSfxDesc }}</div>
                    <div class="queryValue" v-else>-</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.billCurr }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.billCurr !== ''">{{ polMaster.billCurr }} - {{ policyForm.currDesc }}</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.billCurrRate }}</v-subheader>
                    <div class="queryValue">{{ formatCurr(polMaster.billCurrRate) }}</div>
                  </v-flex>
                </v-layout>
                <v-divider />
                <v-layout row wrap>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.scheme }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.scheme">{{ polMaster.scheme }} - {{ policyForm.schemeDesc }}</div>
                    <div class="queryValue" v-else>-</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.promotion }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.promotion">{{ polMaster.promotion }} - {{ policyForm.promotionDesc }}</div>
                    <div class="queryValue" v-else>-</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.finInst }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.finInst">{{ polMaster.finInst }} - {{ policyForm.finInstDesc }}</div>
                    <div class="queryValue" v-else>-</div>
                  </v-flex>
                  <v-flex md4 xs12>
                    <v-subheader class="queryLabel">{{ labels.cpCode }}</v-subheader>
                    <div class="queryValue" v-if="polMaster.cpCode">{{ polMaster.cpCode }} - {{ policyForm.cpCodeDesc }}</div>
                    <div class="queryValue" v-else>-</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
          <v-spacer class="mt-2"></v-spacer>
          <!-- Insured Details -->
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-account-multiple</v-icon><span class="headerTitle">{{ labels.insuredTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.insdRefNo }}</v-subheader>
                          <div class="queryValue">{{ polMaster.insdRefNo }} ({{ formatInsdStat(polMaster.insdStat) }})</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.titleName }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.titleName">{{ formatSalutation(polMaster.titleName) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.fullName }}</v-subheader>
                          <div class="queryValue">
                            {{ polMaster.insdName1 }} {{ polMaster.insdName2 }} {{ polMaster.insdName3 }} {{ polMaster.insdName4 }}
                          </div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.occupation }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.occupation">{{ polMaster.occupation }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.nationality }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.nationality">{{ formatNationality(polMaster.nationality) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.icNo }}</v-subheader>
                          <!-- <div class="queryValue" v-if="polMaster.insdStat==='I' && polMaster.icNo">{{polMaster.icNo}}</div> -->
                          <div class="queryValue" v-if="polMaster.icNo">{{ polMaster.icNo }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.dob }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.dob">{{ formatDate(polMaster.dob) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.gender }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.gender">{{ formatGender(polMaster.gender) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.roc }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.insdStat === 'C' && polMaster.icNoROC">{{ polMaster.icNoROC }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.gstRegNo }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.gstRegNo">{{ polMaster.gstRegNo }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.gstRegDate }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.gstRegDate">{{ formatDate(polMaster.gstRegDate) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.clientType }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.clientType">{{ polMaster.clientType }} - {{ policyForm.clientTypeDesc }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                      </v-layout>
                      <v-divider />
                      <v-layout row wrap>
                        <v-flex xs12>
                          <div class="subheading">{{ labels.mailingAddTitle }}</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.insdAddr1 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.insdAddr1">{{ polMaster.insdAddr1 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.insdAddr2 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.insdAddr2">{{ polMaster.insdAddr2 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.insdAddr3 }}</v-subheader>
                          <div class="queryValue">{{ polMaster.insdAddr3 }}</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.insdAddr4 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.insdAddr4">{{ polMaster.insdAddr4 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.postCode }}</v-subheader>
                          <div class="queryValue">{{ polMaster.postCode }}</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.mobile }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.mobile">{{ polMaster.mobile }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.telNo1 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.telNo1">{{ polMaster.telNo1 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.telNo2 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.telNo2">{{ polMaster.telNo2 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.fax }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.fax">{{ polMaster.fax }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.email }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.email">{{ polMaster.email }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                      </v-layout>
                      <v-divider />
                      <v-layout row wrap>
                        <v-flex xs12>
                          <div class="subheading">{{ labels.altInsuredTitle }}</div>
                        </v-flex>
                        <v-flex xs12>
                          <v-subheader class="queryLabel">{{ labels.altName1 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.altName1">{{ polMaster.altName1 }} {{ polMaster.altName2 }}</div>
                          <!-- <div class="queryValue" v-else>-</div> -->
                        </v-flex>
                        <v-flex xs12 v-if="polMaster.sameInsdAddr">
                          <v-checkbox
                            v-model="polMaster.sameInsdAddr"
                            :label="labels.sameInsdAddr"
                            readonly
                            hide-details
                            class="ma-0 pa-0"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex md4 xs12 v-else>
                          <v-subheader class="queryLabel">{{ labels.altInsdAddr1 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.altInsdAddr1">{{ polMaster.altInsdAddr1 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.altInsdAddr2 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.altInsdAddr2">{{ polMaster.altInsdAddr2 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.altInsdAddr3 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.altInsdAddr3">{{ polMaster.altInsdAddr3 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.altInsdAddr4 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.altInsdAddr4">{{ polMaster.altInsdAddr4 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.altInsdAddr5 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.altInsdAddr5">{{ polMaster.altInsdAddr5 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.altInsdAddr6 }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.altInsdAddr6">{{ polMaster.altInsdAddr6 }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.altPostCode }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.altPostCode">{{ polMaster.altPostCode }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Payment Details -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-credit-card</v-icon><span class="headerTitle">{{ labels.paymentTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card v-if="policyForm.payMeth">
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.paymentMethod }}</v-subheader>
                        </v-flex>
                        <v-flex xs9> </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.payMeth }}</div>
                        </v-flex>
                        <v-flex xs9> </v-flex>
                      </v-layout>
                      <!-- CREDIT BANK -->
                      <v-layout row wrap v-if="policyForm.capCrcdGiro === 'CARD'">
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.crBank }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.crCdType }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.crCdNo }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.cdSecurNo }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.crBank }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ formatCCType(policyForm.crCdType) }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.crCdNo }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.cdSecurNo }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.cdHolderName }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.expMthYr }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.effDate }}</v-subheader>
                        </v-flex>
                        <v-flex xs3> </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.cdHolderName }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ formatRenCnt(policyForm.crExpMth) }}/{{ policyForm.crExpYr }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ formatDate(policyForm.crEffDate) }}</div>
                        </v-flex>
                        <v-flex xs3> </v-flex>
                      </v-layout>
                      <!-- GIRO -->
                      <v-layout row wrap v-else-if="policyForm.capCrcdGiro === 'GIRO'">
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.abbrBankName }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.acctNo }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.giroID }}</v-subheader>
                        </v-flex>
                        <v-flex xs3> </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.drBank }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.giAcctNo }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.giNo }}</div>
                        </v-flex>
                        <v-flex xs3> </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.acctHolderName }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.submitDate }}</v-subheader>
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ labels.giroStat }}</v-subheader>
                        </v-flex>
                        <v-flex xs3> </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.giAcctHolderName }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ formatDate(policyForm.giSubmitDate) }}</div>
                        </v-flex>
                        <v-flex xs3>
                          <div class="queryValue">{{ policyForm.giStat }}</div>
                        </v-flex>
                        <v-flex xs3> </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
                <v-card v-else>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12> No Payment Details </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Miscellaneous Settings -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-settings-box</v-icon><span class="headerTitle">{{ labels.miscSettingsTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.schedEndtFormat }}</v-subheader>
                          <div class="queryValue">{{ formatHyphen(polMaster.schedForm) }} / {{ formatHyphen(polMaster.endtForm) }}</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.premHeading }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.schedPremHead">{{ polMaster.schedPremHead }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.prtMtrBen }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.prtSchedBen">{{ formatYesNo(polMaster.prtSchedBen) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.appShortTerm }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.appShortTerm">{{ formatYesNo(polMaster.appShortTerm) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.appRiskTax }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.appRiskTax">{{ formatYesNo(polMaster.appRiskTax) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.batchRelease }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.batchRel">{{ formatYesNo(polMaster.batchRel) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex xs12>
                          <v-divider class="mt-1"></v-divider>
                        </v-flex>
                        <v-flex xs12>
                          <table class="v-datatable v-table theme--light">
                            <caption></caption>
                            <thead>
                              <tr>
                                <th role="columnheader" scope="col" aria-sort="none" class="column text-xs-left">Print Settings</th>
                                <th role="columnheader" scope="col" aria-sort="none" class="column text-xs-left">Immediate/Later</th>
                                <th role="columnheader" scope="col" aria-sort="none" class="column text-xs-left">No. of Copies</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-xs-left">{{ labels.schedule }}</td>
                                <td class="text-xs-left">{{ formatLn(polMaster.prtSchedLn) }}</td>
                                <td class="text-xs-left">{{ polMaster.noSchedPrt }}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left">{{ labels.drCrNote }}</td>
                                <td class="text-xs-left">{{ formatLn(polMaster.prtDrCrLn) }}</td>
                                <td class="text-xs-left">{{ polMaster.noDrCrPrt }}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left">{{ labels.RiAppln }}</td>
                                <td class="text-xs-left">{{ formatLn(polMaster.prtRiApplnLn) }}</td>
                                <td class="text-xs-left">{{ polMaster.noRiApplnPrt }}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left">{{ labels.ci }}</td>
                                <td class="text-xs-left">{{ formatLn(polMaster.prtCILn) }}</td>
                                <td class="text-xs-left">{{ polMaster.noCIPrt }}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left">{{ labels.taxInv }}</td>
                                <td class="text-xs-left">{{ formatLn(polMaster.prtTaxInvLn) }}</td>
                                <td class="text-xs-left">{{ polMaster.noTaxInvPrt }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Personal Accident Settings -->
            <v-expansion-panel disabled>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-account-box</v-icon><span class="headerTitle">{{ labels.paSettingsTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12> KIV </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Medical Policy Settings -->
            <v-expansion-panel disabled>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-hospital</v-icon><span class="headerTitle">{{ labels.medSettingsTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12> KIV </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Reinsurance Inwards Details -->
            <v-expansion-panel :disabled="polMaster.dri">
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-repeat</v-icon><span class="headerTitle">{{ labels.riTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.cedAnt }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.cedAnt">{{ polMaster.cedAnt }} - {{ policyForm.cedAntName }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.cedAcctNoSfx }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.cedAcctNoSfx">{{ polMaster.cedAcctNoSfx }} - {{ policyForm.cedAcctNoSfxDesc }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.recip }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.recip">{{ polMaster.recip }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.cedSI }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.cedSI">{{ polMaster.cedSI }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.ourSharePct }}</v-subheader>
                          <div class="queryValue" v-if="policyForm.ourSharePct">{{ policyForm.ourSharePct }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.ourShareSI }}</v-subheader>
                          <div class="queryValue" v-if="policyForm.ourShareSI">{{ policyForm.ourShareSI }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.riPer }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.coRiPct">{{ polMaster.coRiPct }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.cedPolNo }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.cedPolNo">{{ polMaster.cedPolNo }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.cedCesNo }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.cedCesNo">{{ polMaster.cedCesNo }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Coinsurance Outwards Settings -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-account-multiple-outline</v-icon><span class="headerTitle">{{ labels.coTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.appCoins }}{{ polMaster.appCoins }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.appCoIns">{{ polMaster.appCoIns ? 'Yes' : 'No' }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.billCoIns }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.billCoIns">{{ polMaster.billCoIns }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex md4 xs12>
                          <v-subheader class="queryLabel">{{ labels.coInsPct }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.coInsPct">{{ polMaster.coInsPct }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Premium Warranty / Contract Certainty -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-security</v-icon><span class="headerTitle">{{ labels.premiumWarrantyTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-subheader class="queryLabel">{{ labels.premWar }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.premWar">{{ polMaster.premWar }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea :label="labels.premWarClause" :rows="5" readonly></v-textarea>
                        </v-flex>
                        <v-flex xs12>
                          <v-subheader class="queryLabel">{{ labels.ccaDate }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.ccaDate">{{ formatDate(polMaster.ccaDate) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex xs12>
                          <v-subheader class="queryLabel">{{ labels.ccdDate }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.ccdDate">{{ formatDate(polMaster.ccdDate) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Policy Text -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-note-text</v-icon><span class="headerTitle">{{ labels.policyTextTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-tabs v-model="polTxtTabMenu" slider-color="teal">
                            <v-tab ripple :key="1">{{ labels.polUppTxt }}</v-tab>
                            <v-tab ripple :key="2">{{ labels.polLwrTxt }}</v-tab>
                            <v-tab ripple :key="3">{{ labels.polMemo }}</v-tab>
                            <v-tab ripple :key="4">{{ labels.polEndtTxt }}</v-tab>
                            <v-tab ripple :key="5">{{ labels.polRenTxt }}</v-tab>
                            <v-tab ripple :key="6">{{ labels.polRenMsg }}</v-tab>
                          </v-tabs>
                          <v-tabs-items v-model="polTxtTabMenu">
                            <v-tab-item :key="1">
                              <v-card>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12>
                                      <v-textarea v-model="polMaster.polUppTxt" :rows="10" readonly></v-textarea>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item :key="2">
                              <v-card>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12>
                                      <v-textarea v-model="polMaster.polLwrTxt" :rows="10" readonly></v-textarea>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item :key="3">
                              <v-card>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12>
                                      <v-textarea v-model="polMaster.polMemo" :rows="10" readonly></v-textarea>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item :key="4">
                              <v-card>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12>
                                      <v-textarea v-model="polMaster.polEndtTxt" :rows="10" readonly></v-textarea>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item :key="5">
                              <v-card>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12>
                                      <v-textarea v-model="polMaster.polRenTxt" :rows="10" readonly></v-textarea>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item :key="6">
                              <v-card>
                                <v-card-text>
                                  <v-layout row wrap>
                                    <v-flex xs12>
                                      <v-textarea v-model="polMaster.polRenMsg" :rows="10" readonly></v-textarea>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Policy Clause -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-note-outline</v-icon><span class="headerTitle">{{ labels.policyClauseTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-data-table
                            :headers="polClse.headers"
                            :items="polClse.items"
                            :loading="polClse.loading"
                            :options.sync="polClse.pagination"
                            item-key="clauseNo"
                            class="elevation-1"
                          >
                            <template v-slot:item="row">
                              <tr>
                                <td>{{ row.item.clauseNo }}</td>
                                <td>{{ row.item.clauseTitle }}</td>
                                <td>{{ row.item.clauseTxt }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Policy Statistics -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-chart-line</v-icon><span class="headerTitle">{{ labels.policyStatsTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-data-table
                            :headers="polHdrStats.headers"
                            :items="polHdrStats.items"
                            item-key="statsType"
                            class="elevation-1"
                            :loading="polHdrStats.loading"
                            :options.sync="polHdrStats.pagination"
                          >
                            <template v-slot:item="row">
                              <tr>
                                <td>{{ row.item.statsType }}</td>
                                <td>{{ row.item.statsTypeDesc }}</td>
                                <td>{{ row.item.statsVal }}</td>
                                <td>{{ row.item.statsValDesc }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Miscellaneous Information -->
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-information</v-icon><span class="headerTitle">{{ labels.miscInfoTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.billType }}</v-subheader>
                          <div class="queryValue">{{ formatBillType(polMaster.billType) }}</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.dept }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.dept !== ''">{{ polMaster.dept }} - {{ policyForm.deptDesc }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.issDate }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.issDate">{{ formatDate(polMaster.issDate) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.retroDate }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.retroDate">{{ formatDate(polMaster.retroDate) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.maintPer }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.maintPer">{{ polMaster.maintPer }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.dliabPer }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.dliabPer">{{ polMaster.dliabPer }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.execIC }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.execIC">{{ polMaster.execIC + ' - ' + polMaster.execICDesc }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.agtUsrId }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.agtUsrId">{{ policyForm.agtUsrName }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.ipcNoSeqNo }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.ipcNo || polMaster.ipcSeqNo">
                            {{ polMaster.ipcNo === null ? '' : polMaster.ipcNo }} {{ polMaster.ipcSeqNo === null ? '' : polMaster.ipcSeqNo }}
                          </div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.ipcDate }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.ipcDate">{{ formatDate(polMaster.ipcDate) }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.ipcStatus }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.ipcStatus">{{ polMaster.ipcStatus }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                        <v-flex sm3 md3 lg3 xs12>
                          <v-subheader class="queryLabel">{{ labels.programID }}</v-subheader>
                          <div class="queryValue" v-if="polMaster.progId">{{ polMaster.progId }}</div>
                          <div class="queryValue" v-else>-</div>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-divider class="mt-2"></v-divider>
                        </v-flex>
                        <v-flex lg12 xs12>
                          <v-toolbar dense color="grey lighten-4" flat>
                            <v-icon>mdi-history</v-icon>
                            <v-toolbar-title class="toolbar-title-2">Transaction History</v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                          <v-data-table
                            :headers="polEntryInfo.headers"
                            :items="polEntryInfo.items"
                            class="elevation-1"
                            hide-default-footer
                            :loading="polEntryInfo.initLoading"
                          >
                            <template v-slot:item="row">
                              <tr>
                                <td>{{ row.item.name }}</td>
                                <td>{{ row.item.dateTime }}</td>
                                <td>{{ row.item.userId }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- Policy Renewal Information -->
            <v-expansion-panel :disabled="policyForm.disablePolRenInfo">
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-refresh</v-icon><span class="headerTitle">{{ labels.polRenInfoTitle }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex sm6 md6 lg6 xs12>
                          <v-checkbox color="primary" v-model="policyForm.confmRen" :label="labels.confmRen" disabled></v-checkbox>
                        </v-flex>
                        <v-flex sm6 md6 lg6 xs12>
                          <v-subheader class="queryGreenLabel">{{ policyForm.polRenInfoText }}</v-subheader>
                        </v-flex>
                        <v-flex sm6 md6 lg6 xs12>
                          <v-subheader class="queryLabel">{{ labels.polRenInfoCreatedDate }}</v-subheader>
                          <div class="queryValue">{{ formatDateTime(policyForm.polRenInfoCreatedDate) }}</div>
                        </v-flex>
                        <v-flex sm6 md6 lg6 xs12>
                          <v-subheader class="queryLabel">{{ labels.polRenInfoCreatedBy }}</v-subheader>
                          <div class="queryValue">{{ policyForm.polRenInfoCreatedBy }}</div>
                        </v-flex>
                        <v-flex sm6 md6 lg6 xs12>
                          <v-subheader class="queryLabel">{{ labels.polRenInfoModifiedDate }}</v-subheader>
                          <div class="queryValue">{{ formatDateTime(policyForm.polRenInfoModifiedDate) }}</div>
                        </v-flex>
                        <v-flex sm6 md6 lg6 xs12>
                          <v-subheader class="queryLabel">{{ labels.polRenInfoModifiedBy }}</v-subheader>
                          <div class="queryValue">{{ policyForm.polRenInfoModifiedBy }}</div>
                        </v-flex>
                        <v-flex sm6 md6 lg6 xs12>
                          <v-subheader class="queryLabel">{{ labels.prtNotDate }}</v-subheader>
                          <div class="queryValue">{{ formatDateTime(policyForm.prtNotDate) }}</div>
                        </v-flex>
                        <v-flex sm6 md6 lg6 xs12>
                          <v-subheader class="queryLabel">{{ labels.prtNotBy }}</v-subheader>
                          <div class="queryValue">{{ policyForm.prtNotBy }}</div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
        <v-tab-item :key="2" :transition="false" :reverse-transition="false">
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <QueryPolicyDetails ref="policyDetails" :functionId="functionId"></QueryPolicyDetails>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="3" :transition="false" :reverse-transition="false">
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <QuerySummary ref="summary" :functionId="functionId"></QuerySummary>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="4" :transition="false" :reverse-transition="false">
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <QueryReinsurance ref="polReinsurance" :functionId="functionId"></QueryReinsurance>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="5" :transition="false" :reverse-transition="false">
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <PolicyCoinsuranceServiceFee ref="coinsSvcFee" :setMode="coinsSvcFeeMode"></PolicyCoinsuranceServiceFee>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="6" :transition="false" :reverse-transition="false">
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <Claims ref="claims"></Claims>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="7" :transition="false" :reverse-transition="false">
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <CustLog ref="custLog" :manageType="manageType"></CustLog>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <!-- </v-card-text> -->
    </v-card>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime4 } from '@/utils/date'
import { salutation, gender, ccType } from '@/const/underwriting'
import QueryPolicyDetails from './QueryPolicyDetails'
import QuerySummary from './QuerySummary'
import Claims from './QueryClaimHeaders'
import CustLog from './QueryCustomerLog'
import QueryReinsurance from './QueryReinsurance'
import PolicyCoinsuranceServiceFee from '../PolicyCoinsuranceServiceFee'

export default {
  data() {
    return {
      labels: {
        policyHeader: 'Policy Header',
        policyDetails: 'Policy Details',
        policySummary: 'Policy Summary',
        policyReinsurance: 'Reinsurance',
        coinsSvcFee: 'Coinsurance Service ',
        claimsInformation: 'Claims Information',
        custLog: 'Customer Log',
        querypolicyHeader: 'Query Policy Transaction',
        return: 'Return',
        polNo: 'Policy No.',
        renEndtCnt: 'Renewal / Endt Count',
        insdName1: 'Insured Name',
        polType: 'Policy Type',
        polStat: 'Policy Status',
        dri: 'Direct or Inwards?',
        branch: 'Branch',
        cty: 'Country of Risk',
        fund: 'Fund',
        busSrc: 'Business Source',
        cnNo: 'CN No.',
        cnDate: 'Date',
        comDate: 'Commencement Date',
        expDate: 'Expiry Date',
        uwYr: 'Underwriting Year',
        endtDate: 'Endorsement Date',
        tranDate: 'Transaction Date',
        firstIssDate: 'First Issue Date',
        acceptDate: 'Acceptance Date',
        acceptTime: 'Acceptance Time',
        headerDetails: 'Header Details',
        prevPolNo: 'Previous Policy No.',
        isMoc: 'Is this an Open Cover / Master Policy?',
        moCmpNo: 'Open Cover / Master Policy No.',
        renPolNo: 'Renewal Policy No.',
        acctNo1: 'Billing Account No.',
        acctNoSfx: 'Suffix',
        billCurr: 'Billing Currency',
        billCurrRate: 'Exchange Rate',
        scheme: 'Scheme',
        promotion: 'Promotion',
        finInst: 'Finance Company',
        cpCode: 'Corporate Partner (ARM)',
        insuredTitle: 'Insured Details',
        paymentTitle: 'Payment Details',
        miscSettingsTitle: 'Miscellaneous Settings',
        paSettingsTitle: 'Personal Accident Settings',
        medSettingsTitle: 'Medical Policy Settings',
        riTitle: 'Reinsurance Inwards Details',
        coTitle: 'Coinsurance Outwards Settings',
        premiumWarrantyTitle: 'Premium Warranty / Contract Certainty',
        policyTextTitle: 'Policy Text / Renewal Message',
        policyClauseTitle: 'Policy Clause',
        policyStatsTitle: 'Policy Statistics',
        miscInfoTitle: 'Miscellaneous Information',
        insdRefNo: 'Insured Reference',
        titleName: 'Salutation',
        fullName: 'Full Name',
        occupation: 'Occupation/Business',
        nationality: 'Nationality',
        icNo: 'NRIC / FIN / Passport No.',
        dob: 'Date of Birth',
        gender: 'Gender',
        individual: 'Individual',
        corporate: 'Corporate',
        roc: 'ROC / UEN',
        gstRegDate: 'GST Reg Date',
        gstRegNo: 'GST Reg No.',
        mailingAddTitle: 'Mailing Address',
        insdAddr1: 'Address 1',
        insdAddr2: 'Address 2',
        insdAddr3: 'Address 3',
        insdAddr4: 'Address 4',
        insdAddr5: 'State',
        insdAddr6: 'Country',
        postCode: 'Postal Code',
        contactInfoTitle: 'Contact Information',
        mobile: 'Mobile No.',
        telNo1: 'Home No.',
        telNo2: 'Office No.',
        fax: 'Fax No.',
        email: 'Email',
        altInsuredTitle: 'Alternate Insured',
        altName1: 'Name',
        altName2: '',
        altMailAddrTitle: 'Mailing Address',
        sameInsdAddr: 'Same as Insured',
        altInsdAddr1: 'Address 1',
        altInsdAddr2: 'Address 2',
        altInsdAddr3: 'Address 3',
        altInsdAddr4: 'Address 4',
        altInsdAddr5: 'State',
        altInsdAddr6: 'Country',
        altPostCode: 'Postal Code',
        ccTitle: 'Credit Card',
        crBank: 'Bank Name',
        crCdType: 'Card Type',
        crCdNo: 'Card No.',
        cdSecurNo: 'CVV',
        crCdExpDate: 'Expiry Date',
        expMthYr: 'Expiry Month / Year',
        cdHolderName: 'Card Holder Name',
        giroTitle: 'GIRO Bank',
        paymentMethod: 'Payment Method',
        abbrBankName: 'Abbreviated Bank Name',
        acctNo: 'Bank Account No.',
        giroID: 'GIRO Id',
        acctHolderName: 'Account Holder Name',
        submitDate: 'Submission Date',
        giroStat: 'GIRO Status',
        printSettings: 'Print Settings',
        immediateLater: 'Immediate / Later',
        noCopies: 'No. of Copies',
        schedule: 'Schedule',
        drCrNote: 'Debit / Credit Note',
        RiAppln: 'RI Closing / Coinsurance Slip',
        ci: 'Certificate of Insurance',
        taxInv: 'Tax Invoice',
        schedEndtFormat: 'Schedule / Endorsement Format',
        premHeading: 'Premium Heading',
        prtMtrBen: 'Print Motor Benefit by',
        appShortTerm: 'Apply Short Term Rate?',
        batchRelease: 'Batch Release',
        appRiskTax: 'Apply Risk Level Tax?',
        billType: 'Billing Type',
        cedAnt: 'Cedant Name',
        cedAcctNoSfx: 'Suffix',
        ourShareSI: 'Our Shared SI',
        ourSharePct: 'Our Share %',
        recip: 'Reciprocal Business?',
        riPer: 'Reinsurance %',
        cedSI: 'Sum Insured',
        cedPolNo: 'Policy No.',
        cedCesNo: 'Cession No.',
        appCoins: 'Apply Coinsurance?',
        billCoIns: 'Bill Coinsurance?',
        coInsPct: 'Coinsurance %',
        premWar: 'Premium Warranty',
        premWarClause: 'Premium Warranty Clause',
        ccaDate: 'Contract Certainty Acceptance Date',
        ccdDate: 'Documentation Date',
        polUppTxt: 'Upper Text',
        polLwrTxt: 'Lower Text',
        polMemo: 'Memo Text',
        polEndtTxt: 'Endorsement Text',
        polRenTxt: 'Renewal Text',
        polRenMsg: 'Renewal Message',
        dept: 'Department',
        issDate: 'Issue Date',
        retroDate: 'Retroactive Date',
        maintPer: 'Maintenance Period (Months)',
        dliabPer: 'Defect Liability (Months)',
        execIC: 'Executive In-charge',
        agtUsrId: 'Agency User ID',
        createdBy: 'Policy Created By',
        createdDate: 'Policy Created On',
        modifiedBy: 'Policy Reviewed By',
        modifiedDate: 'Policy Reviewed On',
        relUsrId: 'Policy Released By',
        relDate: 'Policy Released On',
        ipcNoSeqNo: 'IPC No./Seq No.',
        ipcDate: 'IPC Date',
        ipcStatus: 'IPC Status',
        programID: 'Program ID',
        clientType: 'Client Type',
        polRenInfoTitle: 'Renewal Information',
        confmRen: 'Confirm Renewal',
        prtNotBy: 'Renewal Notice Printed By',
        prtNotDate: 'Renewal Notice Printed Date',
        polRenInfoCreatedBy: 'Renewed By',
        polRenInfoCreatedDate: 'Renewed Date',
        polRenInfoModifiedBy: 'Last Reviewed By',
        polRenInfoModifiedDate: 'Last Reviewed Date',
        acctPeriod: 'Accounting Period'
      },
      policyForm: {
        premOS: undefined,
        polStatDesc: undefined,
        brnDesc: undefined,
        ctyDesc: undefined,
        fundDesc: undefined,
        busSrcDesc: undefined,
        acctNo1Name: undefined,
        acctNoSfxDesc: undefined,
        currDesc: undefined,
        schemeDesc: undefined,
        promotionDesc: undefined,
        finInstDesc: undefined,
        cpCodeDesc: undefined,
        crBank: undefined,
        crCdType: undefined,
        crCdNo: undefined,
        cdSecurNo: undefined,
        cdHolderName: undefined,
        crExpMth: undefined,
        crExpYr: undefined,
        crEffDate: undefined,
        drBank: undefined,
        giAcctNo: undefined,
        giAcctHolderName: undefined,
        giNo: undefined,
        giStat: undefined,
        giSubmitDate: undefined,
        deptDesc: undefined,
        createdName: undefined,
        modifiedName: undefined,
        releasedName: undefined,
        agtUsrName: undefined,
        ourShareSI: undefined,
        ourSharePct: undefined,
        clientTypeDesc: undefined,
        payMeth: undefined,
        capCrcdGiro: undefined,
        disablePolRenInfo: undefined,
        confmRen: undefined,
        polRenInfoText: undefined,
        prtNotBy: undefined,
        prtNotDate: undefined,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDat: undefined
      },
      crCdForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        effDate: undefined,
        expMth: undefined,
        expYr: undefined,
        crBank: undefined,
        crCdType: undefined,
        crCdNo: undefined,
        cdSecurNo: undefined,
        crCdExpDate: undefined,
        cdHolderName: undefined
      },
      bankDrForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        effDate: undefined,
        drBank: undefined,
        acctNo: undefined,
        acctHolderName: undefined,
        giroID: undefined,
        submitDate: undefined,
        giroStat: undefined
      },
      tabMenu: undefined,
      loading: false,
      polTxtTabMenu: undefined,
      polClse: {
        headers: [
          { text: 'Clauses', align: 'left', value: 'clauseNo' },
          { text: 'Clauses Title', value: 'clauseTitle' },
          { text: 'Clauses Text', value: 'clauseTxt' }
        ],
        items: [],
        pagination: {
          itemsPerPage: -1
        },
        clauseRefNo: undefined,
        loading: undefined
      },
      polHdrStats: {
        headers: [
          { text: 'Statistics Type', align: 'left', value: 'statsType' },
          { text: 'Description', value: 'statsTypeDesc' },
          { text: 'Statistics Value', value: '`statsVal`' },
          { text: 'Description', value: 'statsValDesc' }
        ],
        items: [],
        pagination: {
          itemsPerPage: -1
        },
        loading: undefined
      },
      polEntryInfo: {
        headers: [
          { text: 'Action', align: 'left', value: 'name' },
          { text: 'Date/Time', align: 'left', value: 'date' },
          { text: 'User ID', align: 'left', value: 'usrid' }
        ],
        items: [],
        initLoading: false
      },
      showErrorDialog: false,
      manageType: 'policy',
      showTab: true,
      coinsSvcFeeMode: 'query',
      polRenMsg: undefined
    }
  },
  watch: {
    // tabMenu: function (value) {
    //   if (value === 1) {
    //     this.$refs.policyDetails.doInit()
    //   } else if (value === 2) {
    //     this.$refs.summary.doInit()
    //   } else if (value === 3) {
    //     // this.$refs.polReinsurance.doInit()
    //   } else if (value === 4) {
    //   } else if (value === 5) {
    //     this.$refs.claims.doInit()
    //   } else if (value === 6) {
    //     this.$refs.custLog.doInit()
    //   }
    // },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    commonDispatch: function (value) {
      this.setCommonDispatch()
    }
  },
  props: {
    functionId: String
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    policyInfo() {
      return this.$store.state.underwriting.policy.policyInfo
    },
    commonDispatch() {
      return this.$store.state.commons.dispatch
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    ccTypeList() {
      let result = []
      Object.keys(ccType).forEach(function (key) {
        const status = ccType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getPolicyDetails()
      this.fetchPolEntryInfo()
    },
    async getPolicyDetails() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.policyDetails
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt,
            tranType: this.polMaster.tranType
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          this.displayDetails(result).then(() => {
            this.loading = false
          })
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async displayDetails(result) {
      const { data } = result
      if (data) {
        this.policyForm = data
        data.clseList.map(clause => {
          let clauseList = {
            clauseNo: clause.clseNo,
            clauseTitle: clause.clseTitle,
            clauseTxt: clause.clseTxt
          }
          this.polClse.items.push(clauseList)
        })
        data.polHdrStatsList.map((statistic) => {
          const statisticList = {
            statsType: statistic.statsType,
            statsTypeDesc: statistic.statsTypeDesc,
            statsVal: statistic.statsValue,
            statsValDesc: statistic.statsValueDesc
          }
          this.polHdrStats.items.push(statisticList)
        })
      }
    },
    async fetchPolEntryInfo() {
      const apiUrl = this.$store.state.underwriting.policyQuerySettings.menu.getPolEntryInfoList
      if (apiUrl) {
        try {
          this.initLoading = true
          const expand = {
            polType: this.polMaster.polType,
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.polEntryInfoList) {
            result.data.polEntryInfoList.map((polEntryInfo) => {
              if (polEntryInfo.userId !== null && polEntryInfo.userId !== '' && polEntryInfo.userId !== undefined) {
                const convertPolEntryInfo = {
                  name: polEntryInfo.name,
                  dateTime: polEntryInfo.dateTime,
                  userId: polEntryInfo.userId.toUpperCase()
                }
                this.polEntryInfo.items.push(convertPolEntryInfo)
              }
            })
          } else {
            this.polEntryInfo.items = []
          }
          this.initLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.initLoading = false
        }
      }
    },
    setCommonDispatch() {
      if (this.commonDispatch.key === 'ReviewClaim' || this.commonDispatch.key === 'QueryClaim') {
        this.showTab = false
      } else {
        this.showTab = true
      }
    },
    doExit() {
      this.$router.push({ name: 'policyListing' })
    },
    formatTranRel(tranRel) {
      if (tranRel === true) {
        return 'Policy Released'
      } else {
        return ''
      }
    },
    formatRenCnt(renCnt) {
      if (renCnt !== null) {
        return renCnt.toString().padStart(2, '0')
      } else {
        return ''
      }
    },
    formatEndtCnt(endtCnt) {
      if (endtCnt !== null) {
        return endtCnt.toString().padStart(3, '0')
      } else {
        return ''
      }
    },
    formatDRI(dri) {
      if (dri === true) {
        return 'Direct'
      } else {
        return 'Inwards'
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatDateTime(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDateTime4(xDate)
      }
    },
    formatMOC(data) {
      if (data !== undefined && data !== null && data !== '') {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    formatCurr(data) {
      return data.toFixed(6)
    },
    formatInsdStat(data) {
      if (data === 'I') {
        return 'Individual'
      } else if (data === 'C') {
        return 'Corporate'
      } else {
        return ''
      }
    },
    formatSalutation(data) {
      var salutation = this.salutationList.filter((salutation) => {
        return salutation.value === data
      })

      if (salutation.length > 0) {
        return salutation[0].label
      } else {
        return data
      }
    },
    formatGender(data) {
      var gender = this.genderList.filter((gender) => {
        return gender.value === data
      })

      if (gender.length > 0) {
        return gender[0].label
      } else {
        return data
      }
    },
    formatLn(data) {
      if (data === true) {
        return 'Immediate'
      } else {
        return 'Later'
      }
    },
    formatYesNo(data) {
      if (data === true) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    formatNationality(data) {
      if (data === 'SIN') {
        return 'SINGAPOREAN'
      } else if (data === 'SPR') {
        return 'SINGAPORE PR'
      } else if (data === 'OTH') {
        return 'OTHERS'
      } else {
        return ''
      }
    },
    formatCCType(data) {
      var ccType = this.ccTypeList.filter((ccType) => {
        return ccType.value === data
      })

      if (ccType.length > 0) {
        return ccType[0].label
      } else {
        return data
      }
    },
    formatBillType(data) {
      if (data === 'A') {
        return 'Annually'
      } else if (data === 'M') {
        return 'Monthly'
      } else if (data === 'T') {
        return 'Tri-annually'
      } else if (data === 'Q') {
        return 'Quarterly'
      } else {
        return 'Not Applicable'
      }
    },
    doPolicyDetails() {
      // this.$refs.policyDetails.doTab(0)
    },
    doPolicySummary() {
      // this.$refs.summary.doTab(0)
    },
    doPolicyReinsurance() {
      // this.$refs.polReinsurance.doTab(0)
    },
    formatHyphen(data) {
      if (data) {
        return data
      } else {
        return '-'
      }
    }
  },
  components: {
    QueryPolicyDetails,
    QuerySummary,
    QueryReinsurance,
    Claims,
    CustLog,
    PolicyCoinsuranceServiceFee
  },
  mounted() {
    this.setCommonDispatch()
    if (this.$store.state.underwriting.policyQuerySettings.init !== 1) {
      this.$store.dispatch('policyQueryInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>
